/**
 * Onboarding status API (Doc 49) — flags để FE hiển thị banner gợi ý setup.
 */
import { api } from "@/api/client";

export type OnboardingMissing = "odoo_identity" | "llm_key" | string;

export interface OnboardingStatus {
  is_admin: boolean;
  has_password: boolean;
  has_odoo_identity: boolean;
  /** Admin only — null cho non-admin */
  has_any_llm_key: boolean | null;
  /** Admin only */
  ollama_available: boolean | null;
  missing_setup: OnboardingMissing[];
}

export const onboardingApi = {
  status: (): Promise<OnboardingStatus> =>
    api.get<OnboardingStatus>("/api/v1/me/onboarding-status"),
};
